import * as React from "react";
import { cn } from "@/lib/utils";

export interface NoDataProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actionButton?: React.ReactNode;
}

const NoData = React.forwardRef<HTMLDivElement, NoDataProps>(
  ({ className, icon, title, description, actionButton, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "text-center py-12 border-2 border-dashed border-border rounded-lg",
          className
        )}
        {...props}
      >
        <div className="flex flex-col items-center justify-center space-y-3">
          {icon}
          <h3 className="text-lg font-medium text-foreground">{title}</h3>
          {description && (
            <p className="text-muted-foreground max-w-md">{description}</p>
          )}
          {actionButton}
        </div>
      </div>
    );
  }
);

NoData.displayName = "NoData";

export { NoData };